import { styled } from '@clickcease/cc-client-components-lib'

export const PricingFooterStyled = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
  background: 'linear-gradient(180deg, rgba(136, 179, 231, 0.2) 0%, rgba(136, 179, 231, 0) 100%)',
})
